<div [ngStyle]="style" class="skeleton-loading"></div>